import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Variant = makeShortcode("Variant");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Variant platform="android" task="add" repeat="3" mdxType="Variant" />
    <h4 {...{
      "id": "java"
    }}>{`Java`}</h4>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Add the `}<inlineCode parentName="p">{`UserProfile`}</inlineCode>{` library to your project using the app's gradle file.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Import the `}<inlineCode parentName="p">{`UserProfile`}</inlineCode>{` library and any other SDK library in your application's main activity.`}</p>
      </li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`import com.adobe.marketing.mobile.*;
`}</code></pre>
    <Variant platform="ios" task="add" repeat="7" mdxType="Variant" />
    <ol>
      <li parentName="ol">{`Add the Mobile Core and Profile extensions to your project using Cocoapods. Add following pods in your `}<inlineCode parentName="li">{`Podfile`}</inlineCode>{`:`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-pod"
      }}>{`use_frameworks!
target 'YourTargetApp' do
    pod 'ACPCore'
    pod 'ACPUserProfile'
end
`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Import the UserProfile library.   `}</li>
    </ol>
    <h4 {...{
      "id": "objective-c"
    }}>{`Objective-C`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`   #import "ACPCore.h"
   #import "ACPUserProfile.h"
`}</code></pre>
    <h4 {...{
      "id": "swift"
    }}>{`Swift`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`   import ACPCore
   import ACPUserProfile
`}</code></pre>
    <Variant platform="cordova" task="add" repeat="3" mdxType="Variant" />
    <h4 {...{
      "id": "cordova"
    }}>{`Cordova`}</h4>
    <p>{`After creating your Cordova app and adding the Android and iOS platforms, the UserProfile extension for Cordova can be added with this command:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`cordova plugin add https://github.com/adobe/cordova-acpuserprofile.git
`}</code></pre>
    <Variant platform="unity" task="add" repeat="3" mdxType="Variant" />
    <h4 {...{
      "id": "c"
    }}>{`C#`}</h4>
    <p>{`After importing the `}<a parentName="p" {...{
        "href": "https://github.com/adobe/unity-acpuserprofile/blob/master/bin/ACPUserProfile-0.0.1-Unity.zip"
      }}>{`ACPUserProfile.unitypackage`}</a>{`, the UserProfile extension for Unity can be added with following code in the MainScript`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`using com.adobe.marketing.mobile;
`}</code></pre>
    <Variant platform="xamarin" task="add" repeat="3" mdxType="Variant" />
    <h4 {...{
      "id": "c-1"
    }}>{`C#`}</h4>
    <p>{`After adding the iOS ACPUserProfile NuGet package or the Android ACPUserProfile NuGet package, the UserProfile extension can be added by this import statement`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`using Com.Adobe.Marketing.Mobile;
`}</code></pre>
    <Variant platform="android" task="register" repeat="5" mdxType="Variant" />
    <h4 {...{
      "id": "java-1"
    }}>{`Java`}</h4>
    <p><strong parentName="p">{`Required:`}</strong>{` The `}<inlineCode parentName="p">{`setApplication()`}</inlineCode>{` method must be called once in the `}<inlineCode parentName="p">{`onCreate()`}</inlineCode>{` method of your main activity.`}</p>
    <ol>
      <li parentName="ol">{`The `}<inlineCode parentName="li">{`UserProfile`}</inlineCode>{` extension must be registered with Mobile Core before calling an `}<inlineCode parentName="li">{`UserProfile`}</inlineCode>{` API.`}</li>
    </ol>
    <p>{`This can be done after calling `}<inlineCode parentName="p">{`setApplication()`}</inlineCode>{` in the `}<inlineCode parentName="p">{`onCreate()`}</inlineCode>{` method. Here is a code sample, which calls these set up methods:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-java"
      }}>{`   public class MobileApp extends Application {

       @Override
       public void onCreate() {
           super.onCreate();
           MobileCore.setApplication(this);
           try {
               // register other extensions
               UserProfile.registerExtension();
               MobileCore.start(new AdobeCallback () {
                   @Override
                   public void call(Object o) {
                       MobileCore.configureWithAppID("yourAppId");
                   }
               });    
           } catch (Exception e) {
               //Log the exception
            }
       }
   }
`}</code></pre>
    <Variant platform="ios" task="register" repeat="4" mdxType="Variant" />
    <h4 {...{
      "id": "swift-1"
    }}>{`Swift`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`func application(_ application: UIApplication, didFinishLaunchingWithOptions launchOptions: [UIApplication.LaunchOptionsKey: Any]?) -> Bool {
     ACPCore.configure(withAppId: "yourAppId")   
     ACPUserProfile.registerExtension() 
     ACPCore.start(nil)
     // Override point for customization after application launch. 
     return true;
}
`}</code></pre>
    <h4 {...{
      "id": "objective-c-1"
    }}>{`Objective-C`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-objectivec"
      }}>{`- (BOOL)application:(UIApplication *)application didFinishLaunchingWithOptions:(NSDictionary *)launchOptions {
  [ACPUserProfile registerExtension];
  // Override point for customization after application launch.
  return YES;
}
`}</code></pre>
    <Variant platform="react-native" task="register" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "javascript"
    }}>{`JavaScript`}</h4>
    <p>{`When using React Native, register Profile with Mobile Core in native code as shown on the Android and iOS tabs.`}</p>
    <Variant platform="flutter" task="register" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "flutter"
    }}>{`Flutter`}</h4>
    <p>{`When using Flutter, register Profile with Mobile Core in native code as shown on the Android and iOS tabs.`}</p>
    <Variant platform="cordova" task="register" repeat="2" mdxType="Variant" />
    <h4 {...{
      "id": "cordova-1"
    }}>{`Cordova`}</h4>
    <p>{`When using Cordova, register Profile with Mobile Core in native code as shown on the Android and iOS tabs.`}</p>
    <Variant platform="unity" task="register" repeat="3" mdxType="Variant" />
    <h4 {...{
      "id": "c-2"
    }}>{`C#`}</h4>
    <p>{`Register the extension in the `}<inlineCode parentName="p">{`start()`}</inlineCode>{` function:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`using com.adobe.marketing.mobile;
using using AOT;

public class MainScript : MonoBehaviour
{
    [MonoPInvokeCallback(typeof(AdobeStartCallback))]
    public static void HandleStartAdobeCallback()
    {   
        ACPCore.ConfigureWithAppID("yourAppId"); 
    }

    // Start is called before the first frame update
    void Start()
    {   
        ACPUserProfile.registerExtension();
        ACPCore.Start(HandleStartAdobeCallback);
    }
}
`}</code></pre>
    <Variant platform="xamarin" task="register" repeat="7" mdxType="Variant" />
    <h4 {...{
      "id": "c-3"
    }}>{`C#`}</h4>
    <p><strong parentName="p">{`iOS`}</strong></p>
    <p>{`Register the User Profile extension in your app's `}<inlineCode parentName="p">{`FinishedLaunching()`}</inlineCode>{` function:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`public override bool FinishedLaunching(UIApplication app, NSDictionary options)
{
  global::Xamarin.Forms.Forms.Init();
  LoadApplication(new App());
  ACPUserProfile.RegisterExtension();
  // start core
  ACPCore.Start(startCallback);
  return base.FinishedLaunching(app, options);
}

private void startCallback()
{
  // set launch config
  ACPCore.ConfigureWithAppID("yourAppId");
}
`}</code></pre>
    <p><strong parentName="p">{`Android`}</strong></p>
    <p>{`Register the User Profile extension in your app's `}<inlineCode parentName="p">{`OnCreate()`}</inlineCode>{` function:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-csharp"
      }}>{`protected override void OnCreate(Bundle savedInstanceState)
{
  base.OnCreate(savedInstanceState);
  global::Xamarin.Forms.Forms.Init(this, savedInstanceState);
  LoadApplication(new App());
  ACPUserProfile.RegisterExtension();

  // start core
  ACPCore.Start(new CoreStartCompletionCallback());
}

class CoreStartCompletionCallback : Java.Lang.Object, IAdobeCallback
{
  public void Call(Java.Lang.Object callback)
  {
    // set launch config
    ACPCore.ConfigureWithAppID("yourAppId");
  }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      